import Vue from "vue";

import {
  message,
  Modal
} from 'ant-design-vue';

const namespaced = true;

function initialState() {
  return {
    bookings: {}
  };
}

const state = {
  bookings: initialState().bookings,
};

const mutations = {
  SET_BOOKING: (state, booking) => {
    Vue.set(state.bookings, booking.id, booking);
  },
  UNSET_BOOKING: (state, id) => {
    Vue.delete(state.bookings, id);
  }
};

const actions = {
  create: ({
    commit
  }, booking) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`/booking`, {
          booking: booking
        })
        .then(response => {
          commit("SET_BOOKING", response.data.booking);
          message.success(`Booking has been created!`);
          resolve(response.data.booking);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchSingle: ({
    commit
  }, {
    id,
    include
  }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`/booking/${id}?include=${include}`)
        .then(response => {
          commit("SET_BOOKING", response.data.booking);
          resolve(response.data.booking);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchAllByEvent: ({
    commit
  }, {
    eventId,
    isPublic
  }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${isPublic ? '/public' : ''}/booking/getByEvent/${eventId}`)
        .then(response => {
          for (const booking of response.data.bookings) {
            commit("SET_BOOKING", booking);
          }
          resolve();
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchAll: ({
    commit
  }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`/booking${data.queryString ? '?' + data.queryString : ''}`)
        .then(response => {
          for (const booking of response.data.bookings) {
            commit("SET_BOOKING", booking);
          }
          resolve(response.data.bookings);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  update: ({
    commit
  }, booking) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(`/booking/${booking.id}`, {
          booking: booking
        })
        .then(response => {
          commit("SET_BOOKING", response.data.booking);
          message.success(`Booking has been created!`);
          resolve(response.data.booking);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  delete: ({
    state,
    commit
  }, id) => {
    return new Promise((resolve, reject) => {

      const booking = state.bookings[id];

      Modal.confirm({
        title: 'Delete booking',
        content: `Permanently delete booking. Continue?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: () => {
          Vue.axios
            .delete(`/admin/booking/${id}`)
            .then(response => {
              commit("UNSET_BOOKING", id);
              message.success(`Booking has been deleted!`);
              resolve();
            })
            .catch(error => {
              message.error(`Error while deleting booking!`);
              Vue.prototype.$log.error(error);
            });
        }
      });
    });
  }
};

const getters = {
  all: (state, getters, rootState) => {
    if (rootState.isLoading) return {};
    return state.bookings;
  },
  asArray: (state, getters, rootState) => {
    if (rootState.isLoading) return [];
    return Object.values(state.bookings);
  }
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
};